<template>
  <!-- 优选律师 -->
  <div class="good_lawyer margin_auto text_center">
<div class="flex between">
	<sec-title
	  ac-text="优选"
	  Text="律师"
	  desc-text="甄选优质律师，帮您快速找到合适的律师"
	  :showmore = 'false'
	></sec-title>
	<div class="rznow">
		律师入驻
	</div>
</div>

    <div class="between">
      <lay-item-win2
        class="item"
        v-for="(item, index) in laywerlist"
        :key="index"
		:item = 'item'
      ></lay-item-win2>
    </div>
    <div class="gl_reason between">
      <div class="gl_reason_left">
        <div class="title">选择优选律师的理由</div>
        <div class="between">
          <div class="reason_item">
            <div>
              <img src="~assets/home/reson_1.png" />
            </div>
            <div>头像认证</div>
          </div>
          <div class="reason_item">
            <div><img src="~assets/home/reson_2.png" /></div>
            <div>职业认证</div>
          </div>
          <div class="reason_item">
            <div>
              <img src="~assets/home/reson_3.png" />
            </div>
            <div>手机认证</div>
          </div>
        </div>
      </div>
      <ul class="advantage">
        <img src="../../../assets/home/yxlsycbg.png" alt="" />
      </ul>
    </div>
  </div>
</template>

<script>
import layItemWin2 from "../components/layItemWin2";
import secTitle from "../components/secTitle";
export default {
  components: {
    secTitle,
    layItemWin2,
  },
  data(){
	  return{
		  laywerlist:''
	  }
  },
  created() {
  	this.$http.home.lawyerads({
  		ad_id:1,
  		limit:4,
  		order:'hot'
  	}).then(res => {
  		this.laywerlist = res.data.data
  	})
  }
};
</script>

<style lang="scss" scoped>
.good_lawyer {
  width: 1200px;
  padding: 50px 0;
  .item {
    width: 274px;
    height: 360px;
  }
	.rznow{
		width: 114px;
		height: 36px;
		border: 1px solid #222222;
		font-size: 22px;
		font-weight: 400;
		color: #222222;
		line-height: 30px;
	}
  .gl_reason {
    margin-top: 30px;
    .gl_reason_left {
      width: 710px;
      height: 250px;
      .title {
        text-align: left;
        padding-left: 13px;
        margin-bottom: 30px;
        font-size: 22px;
        color: #333333;
        border-left: 4px solid #0465ea;
      }
      .reason_item {
        width: 224px;
        height: 192px;
        padding: 38px 67px;
        border: 1px solid #cddcf1;
        border-radius: 10px;
        font-size: 20px;
        color: #666;
        img {
          margin-bottom: 23px;
        }
      }
    }
    .advantage {
      width: 460px;
      height: 250px;
      box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.08);
      img {
        width: 460px;
        height: 250px;
      }
    }
  }
}
</style>